import { PlanActionType } from '../../context/plan/actions';
import { usePlanContext } from '../../context/plan/context';
import { SelectionActionType } from '../../context/selection/actions';
import { useSelectionContext } from '../../context/selection/context';

export const useCleanActivePlan = (): { run: Function } => {
  const { planDispatch } = usePlanContext();
  const { selectionDispatch } = useSelectionContext();
  return {
    run: async () => {
      planDispatch({
        type: PlanActionType.SET_ACTIVE_PLAN,
        payload: {
          activePlan: undefined,
        },
      });
      planDispatch({
        type: PlanActionType.SET_ACTIVE_PLAN_EDITING_GEO_FENCE,
        payload: {
          editingGeoFence: undefined,
        },
      });
      planDispatch({
        type: PlanActionType.SET_ACTIVE_PLAN_OPTIMIZATION_DATA,
        payload: {
          status: undefined,
          startedAt: undefined,
        },
      });
      selectionDispatch({
        type: SelectionActionType.SET_ACTIVE_PLAN_SELECTED_DRIVERS,
        payload: {
          selectedDrivers: [],
        },
      });
      selectionDispatch({
        type: SelectionActionType.SET_ACTIVE_PLAN_SELECTED_STOPS,
        payload: {
          selectedStops: [],
        },
      });
      planDispatch({
        type: PlanActionType.SET_ACTIVE_PLAN_FOCUSED_STOP,
        payload: {
          focusedStop: undefined,
        },
      });
    },
  };
};
